var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AutoTestFixture_1;
import { immutable } from '@/utils';
let AutoTestFixture = AutoTestFixture_1 = class AutoTestFixture {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, name, hidden) {
        this.id = id;
        this.name = name;
        this.hidden = hidden;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new AutoTestFixture_1(data.id, data.name, data.hidden);
    }
};
AutoTestFixture = AutoTestFixture_1 = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], AutoTestFixture);
export { AutoTestFixture };
